/**
 * @description Convert a camel case string to a sentence case string.
 * @example mooCow to Moo Cow.
 * @param {string} text
 * @return {string}
 */
export function reverseCamelCase(text: string): string {
  const result = text.replace(/([A-Z])/g, ' $1');
  return result.charAt(0).toUpperCase() + result.slice(1);
}
